<template>
  <el-dialog class="report-dialog" v-bind="$attrs" v-on="$listeners" width="400px" append-to-body>
    <div class="report-header" slot="title">
      <strong>举报</strong>
      <span>请选择原因（可多选）</span>
    </div>

    <el-checkbox-group class="report-list" v-model="reportNames">
      <el-checkbox class="report-item" v-for="(item, i) in list" :key="i" :label="item.name">{{
        item.name
      }}</el-checkbox>
    </el-checkbox-group>

    <el-input
      class="report-reason"
      type="textarea"
      v-model="reason"
      :rows="2"
      resize="none"
      placeholder="请输入您想反馈的问题"
    >
    </el-input>

    <div class="report-footer" slot="footer">
      <el-button size="medium" @click="$emit('update:visible', false)">取消</el-button>
      <el-button size="medium" type="primary" @click="sendMail">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'DialogReport',
  props: { list: Array },
  data() {
    return {
      // 选中的举报选项
      reportNames: [],
      // 举报原因
      reason: '',
    };
  },
  methods: {
    /**
     * 发送邮件
     */
    sendMail() {
      if (!this.reportNames.length) return this.$warning('请选择举报类型');
      const separator = '%0d%0a';
      location = `mailto:admin@yorkbbs.ca?subject=举报&body=举报类型: ${this.reportNames.join(
        ',',
      )} ${separator}举报描述: ${this.reason} ${separator}文章链接: ${location.href}`;

      this.reportNames = [];
      this.reason = '';
      this.$emit('update:visible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.report-dialog {
  ::v-deep {
    .el-dialog__body {
      padding-top: 10px;
      padding-bottom: 20px;
    }
  }
}
.report-header {
  display: flex;
  align-items: center;
  strong {
    font-size: 16px;
    font-weight: 500;
  }
  span {
    font-size: 14px;
    color: var(--text-color-9);
    margin-left: 10px;
  }
}

.report-list {
  display: flex;
  flex-direction: column;
}

.report-item {
  padding: 10px 0;
  margin-right: 0;

  &:not(:last-child) {
    border-bottom: 1px solid #efeff1;
  }

  display: flex;
  align-items: center;

  ::v-deep {
    .el-checkbox__input {
      display: flex;
    }
    .el-checkbox__label {
      font-size: 14px;
      color: var(--text-color-3);
    }
  }
}
.report-reason {
  margin-top: 15px;
  ::v-deep {
    .el-textarea__inner {
      border: 0 none;
      background-color: #f8f8f8;
      padding: 20px;
    }
  }
}
</style>
